import React from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getUserLoansDetail } from 'services/fund'
import posthog from 'posthog-js'

export default function useGetLoans() {
    const { moneyPool, loanId } = useParams()
    const { data, isLoading } = useQuery(
        ['user-loans-detail-page', moneyPool, loanId],
        getUserLoansDetail,
        {
            onError: (error: any) => {
                posthog.capture('loan_detail_load_failed', {
                    fund_id: moneyPool,
                    loan_id: loanId,
                    status: error?.response?.status,
                })
            },
        }
    )
    return { data, isLoading }
}
